import React, { useState, useEffect } from 'react';
import image1 from '../../assets/images/banner/banner1.webp';
import image2 from '../../assets/images/banner/banner2.webp';
import image3 from '../../assets/images/banner/banner3.webp';
import image4 from '../../assets/images/banner/banner4.webp';
import image5 from '../../assets/images/banner/banner5.webp';
import {useTranslation} from "react-i18next";
import './style.scss';

const Banner = () => {
    const {t} = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    const images = [
        image2, // Image 1
        image1, // Image 2
        image3, // Image 3
        image4,  // Image 4
        image5,  // Image 5
    ];

    const handleDotClick = (index) => {
        setActiveIndex(index);
    };

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setActiveIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 2500);

        return () => clearInterval(slideInterval);
    }, [images.length]);

    return (
        <div className="banner-container" style={{ backgroundImage: `url(${images[activeIndex]})` }}>
            <div id="home" className="banner-content">
                <div className="banner-left text-container">
                    <h2>{t(`banner.tagline${activeIndex}`)}</h2>
                    <p>{t(`banner.description${activeIndex}`)}</p>
                </div>
                <div className="banner-right">
                    <div className="slider">
                        <div
                            className="slider-wrapper"
                            style={{ transform: `translateX(-${activeIndex * 415}px)` }} /* Each card + 15px gap */
                        >
                            {images.map((image, index) => (
                                <div className="slider-card" key={index}>
                                    <img src={image} alt={`Slider ${index + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="slider-dots">
                        {images.map((_, index) => (
                            <span
                                key={index}
                                className={`dot ${index === activeIndex ? 'active' : ''}`}
                                onClick={() => handleDotClick(index)}
                            ></span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;